import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiFetch, getToken } from "@/api";
import { Spinner, Button } from "@/ui";

export default function SocialJoin() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      if (!getToken()) { navigate(`/onboarding?join=${token}`); return; }
      try {
        const d = await apiFetch("/social/rooms/join", { method: "POST", body: { token } });
        navigate(`/social/${d.room.id}`, { replace: true });
      } catch (e) {
        if (e.status === 402) return navigate("/paywall");
        setError(e.message || "That invite link isn't valid.");
      }
    })();
  }, [token, navigate]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center text-foreground">
      {error ? (
        <>
          <p data-testid="join-error" className="max-w-xs text-muted-foreground">{error}</p>
          <Button onClick={() => navigate("/social")}>Go to Messages</Button>
        </>
      ) : (
        <>
          <Spinner className="h-7 w-7 text-foreground" />
          <p className="text-muted-foreground">Joining the chat…</p>
        </>
      )}
    </div>
  );
}
